var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowi = function SvgArrowi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 24V0h24v24z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M9 8.175 12.708 12 9 15.825 10.142 17 15 12l-4.858-5z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowi);
export default ForwardRef;